module.exports = __webpack_public_path__ + "img/20500901.b48d7c7c.png";